import { FeatureFlag, PermissionSlug } from '../../constants/featureFlags';
import { useStore } from '../../store';

/**
 * Whether the current user may use Payroll Manager.
 *
 * One definition for the sidebar entry and both payroll screens — the rule is a
 * feature flag plus either of two permission slugs, and a partial edit across
 * three copies would give a nav link that renders a permission error.
 *
 * Selects the decision rather than the inputs. `hasFeatureFlag` and
 * `hasAnyPermission` are created once in the slice factory and read `get().user`
 * at call time, so a selector returning them is permanently shallow-equal and
 * would never recompute; one returning `user` recomputes correctly but
 * re-renders on every /auth/me poll, which replaces the user object every two
 * minutes and on each tab refocus. Returning the boolean keeps it live and lets
 * zustand's default Object.is drop the re-render unless access actually flips.
 */
export function usePayrollAccess(): boolean {
  return useStore(
    state =>
      !!state.user &&
      state.hasFeatureFlag(FeatureFlag.PAYROLL_MANAGER) &&
      state.hasAnyPermission([
        PermissionSlug.PAYROLL_ACCESS,
        PermissionSlug.EMR_MANAGE,
      ])
  );
}
